export default (element) => {
    const body = document.querySelector('body');
    const backInStockX  = document.querySelectorAll('.back-in-stock__x');
    const overlay = document.querySelector('.back-in-stock__overlay');
    const closeBackInStockButton = element.querySelector(
      '[data-target="close-back-in-stock-button"]',
    );
  
    const backInStockFormContainer = element.querySelector(
      '[data-target="back-in-stock-form-container"]',
    );
  
    const backInStockOverlay = element.querySelector(
      '[data-target="back-in-stock-overlay"]',
    );
  
    const backInStockForm = element.querySelector('[data-form-variant-id]');
  
    const init = () => {
      backInStockOverlay?.addEventListener('click', closeBackInStock);
      closeBackInStockButton?.addEventListener('click', closeBackInStock);
  
      window.addEventListener('resize', closeBackInStock);
  
      backInStockFormContainer.addEventListener('openPanel', (event) => {
        const { currentVariant } = event.detail;
        const { product } = event.detail;
        const titleTextContainer = element.querySelector(
          '[data-target="back-in-stock-product-title"]',
        );
        const variantTextContainer = element.querySelector(
          '[data-target="back-in-stock-variant-title"]',
        );
  
        window.TMW.oos_variant = currentVariant;
  
        if (product.title && titleTextContainer) {
          titleTextContainer.textContent = product.title;
        }
  
        if (variantTextContainer) {
          let variantText =
            '<span class="hidden lg:inline-block"> /&nbsp;</span>';
          variantTextContainer.innerHTML = '';
          if (currentVariant.selectedOptions) {
            variantText = currentVariant.selectedOptions.reduce((acc, cur,index) => `${acc}${index > 0 ? ' / ' : ''}${cur.value}`, "");
          }
          variantTextContainer.innerHTML = variantText;
        }
  
        if (backInStockForm) {
          backInStockForm.setAttribute(
            'data-form-variant-id',
            currentVariant.id.split('/ProductVariant/')[1],
          );
        }
  
        openBackInStock();
      });
    };
  
    const openBackInStock = () => {
      backInStockX.forEach(item => {
        item.classList.add('!translate-x-0')
      }) 
      body.classList.add('back-in-stock-opened', 'overflow-hidden');
      overlay.classList.remove('hidden');
      
    };
  
    const closeBackInStock = () => {
      body.classList.remove('back-in-stock-opened', 'overflow-hidden');
      backInStockX.forEach(item => {
        item.classList.remove('!translate-x-0')
      }) 
      overlay.classList.add('hidden');
    };
  
    init();
  };